import _ from 'lodash';
import { createSelector } from 'reselect';
import { getModules, getCurrentModuleSlug } from './core';
import { getLocale } from './preferences';

const getModuleSlugToModuleMap = createSelector(getModules, modules =>
  _.reduce(
    modules,
    (result, module) => ({ ...result, [module.acf.chapter_number]: module }),
    {}
  )
);

const getCurrentModule = createSelector(
  getModuleSlugToModuleMap,
  getCurrentModuleSlug,
  (slugToModuleMap, moduleSlug) => slugToModuleMap[moduleSlug]
);

const getLearnModulesForCurrentLocale = createSelector(
  getModules,
  modules => modules
);

const getDischargeModuleForCurrentLocale = createSelector(
  getModules,
  getLocale,
  (modules, locale) =>
    _.find(
      modules,
      module => module.isDischarge && module.languageId === locale
    )
);

export {
  getModuleSlugToModuleMap,
  getCurrentModule,
  getLearnModulesForCurrentLocale,
  getDischargeModuleForCurrentLocale
};



// WEBPACK FOOTER //
// ./src/selectors/modules.js